import { Injectable } from '@angular/core';

import { Cargochief } from '@service/cargochief/cargochief.service';
import { USER_ROLES } from '@domain/constants/app-variables';

@Injectable({
	providedIn: 'root',
})
export class UserRoleService {
	constructor(private cargochief: Cargochief) {}

	get CARRIER_RECRUITER(): boolean {
		const roles = this.getUserRoles();
		if (roles) {
			return roles.indexOf(USER_ROLES.CARRIER_RECRUITER) !== -1;
		}
		return false;
	}

	get OWNER(): boolean {
		const roles = this.getUserRoles();
		if (roles) {
			return roles.indexOf(USER_ROLES.OWNER) !== -1;
		}
		return false;
	}

	get ADMIN(): boolean {
		const roles = this.getUserRoles();
		if (roles) {
			return roles.indexOf(USER_ROLES.ADMIN) !== -1;
		}
		return false;
	}

	get USER(): boolean {
		const roles = this.getUserRoles();
		if (roles) {
			return roles.indexOf(USER_ROLES.USER) !== -1;
		}
		return false;
	}

	get CARRIER_RECRUITING_ADMIN(): boolean {
		const roles = this.getUserRoles();
		if (roles) {
			return roles.indexOf(USER_ROLES.CARRIER_RECRUITING_ADMIN) !== -1;
		}
		return false;
	}

	getUserRoles(): any {
		return this.cargochief?.getUser()?.role;
	}
}
